'use strict';

var React = require('react'),
    connect = require('react-redux').connect,
    dialogsActions = require('../actions/dialogsActions'),
    flashError = dialogsActions.flashError,
    getThumURL = require('thum.io').getThumURL;

function getThumUrlForKey(key, testUrl) {
	return testUrl ? getThumURL({
		auth: {
			keyId: key.id,
			type: key.type === 'md5signed' ? 'md5' : key.type,
			secret: key.value
		},
		url: testUrl,
		protocol: 'https'
	}) : '';
}

var KeyPreview = React.createClass({
	displayName: 'KeyPreview',

	propTypes: {
		dispatch: React.PropTypes.func.isRequired,
		keyModel: React.PropTypes.object.isRequired
	},

	getInitialState: function getInitialState() {
		return {
			previewUrl: null,
			loadingImage: true,
			testUrl: 'https://www.wikipedia.org/'
		};
	},

	componentWillMount: function componentWillMount() {
		this.setPreviewUrl();
	},

	render: function render() {
		var previewUrl = this.state.previewUrl;

		return React.createElement(
			'div',
			{ className: 'row' },
			React.createElement(
				'h3',
				{ className: 'col-md-12 page-subheader' },
				'Try it out!'
			),
			React.createElement(
				'form',
				{ onSubmit: this.submitTestUrl, className: 'col-md-6' },
				React.createElement(
					'div',
					{ className: 'form-group' },
					React.createElement(
						'label',
						null,
						'URL'
					),
					React.createElement('input', {
						className: 'form-control',
						type: 'text',
						value: this.state.testUrl,
						onChange: this.updateTestUrl,
						autoFocus: true
					})
				),
				React.createElement(
					'button',
					{ type: 'submit', className: 'btn btn-primary' },
					'Preview generated screenshot'
				)
			),
			React.createElement(
				'div',
				{ className: 'col-md-6' },
				React.createElement(
					'strong',
					null,
					'Generated screenshot'
				),
				React.createElement('br', null),
				React.createElement(
					'div',
					{ className: 'key-wizard-screenshot-preview' },
					React.createElement('img', { src: this.state.loadingImage ? '/spinners/0.gif' : previewUrl, alt: '' })
				),
				React.createElement('br', null),
				React.createElement(
					'strong',
					null,
					'Generated screenshot URL'
				),
				React.createElement('br', null),
				React.createElement(
					'a',
					{ href: previewUrl, target: '_blank', className: 'ellipsis' },
					previewUrl
				)
			)
		);
	},

	setPreviewUrl: function setPreviewUrl() {
		// Fake loading icon so it's obvious that the image changes
		this.setState({
			loadingImage: true,
			previewUrl: getThumUrlForKey(this.props.keyModel, this.state.testUrl)
		});

		setTimeout(this.stopLoading, 1000);
	},

	stopLoading: function stopLoading() {
		this.setState({ loadingImage: false });
	},

	updateTestUrl: function updateTestUrl(e) {
		this.setState({ testUrl: e.target.value });
	},

	submitTestUrl: function submitTestUrl(e) {
		e.preventDefault();

		if (!this.state.testUrl) {
			this.props.dispatch(flashError('Need to specify a URL to test'));
			return;
		}

		this.setPreviewUrl();
	}
});

module.exports = connect()(KeyPreview);


//////////////////
// WEBPACK FOOTER
// ./client/components/KeyPreview.js
// module id = 255
// module chunks = 5